import src from "IMAGE";
export default { src, width: 640, height: 640, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAAQElEQVR42r2OwRHAIAgEbSbJZATBQ+i/NKEI3efePq6187wJADUzENHPzF1EOB1qq+ApqaojIpa7WwUz+ZILHzfhiQtsh9AfRgAAAABJRU5ErkJggg==", blurWidth: 8, blurHeight: 8 }
